// Recovery phrase helpers (client side). The phrase is the human-readable form
// of the key-wrapping secret: the user's private PQC keys are sealed with
// KDF(password) AND independently with KDF(phrase), so either unlocks them.
// Server never sees the phrase. Word list: BIP-39 English (2048 words) — wire
// `WORDLIST` to the full list in production; the short list here keeps the
// bundle small for the shell.
export const WORDLIST = ['harbor', 'velvet', 'quantum', 'lantern', 'orbit', 'saffron', 'granite', 'meadow', 'cipher', 'ember', 'tundra', 'willow', 'basalt', 'comet', 'delta', 'fjord', 'glacier', 'ivory', 'juniper', 'kestrel', 'lumen', 'mosaic', 'nectar', 'osprey', 'prism', 'quartz', 'ripple', 'summit', 'timber', 'umber', 'vortex', 'zephyr'];

export function generatePhrase(words = 12) {
  const buf = new Uint32Array(words);
  crypto.getRandomValues(buf);
  return Array.from(buf, (n) => WORDLIST[n % WORDLIST.length]);
}

export const normalizeWords = (arr) => arr.map((w) => (w || '').trim().toLowerCase());

/** Returns index of first mismatch, or -1 when the phrase matches. */
export function firstMismatch(entered, expected) {
  const e = normalizeWords(entered);
  for (let i = 0; i < expected.length; i++) if (e[i] !== expected[i]) return i;
  return -1;
}

/** Distribute a pasted phrase across inputs starting at index i. */
export function spreadPaste(words, i, raw) {
  const next = [...words];
  if (/\s/.test(raw.trim())) raw.trim().split(/\s+/).slice(0, words.length - i).forEach((w, j) => { next[i + j] = w.toLowerCase(); });
  else next[i] = raw.toLowerCase().trim();
  return next;
}

export function passwordScore(pw = '') {
  return Math.min(4, (pw.length >= 12) + /[A-Z]/.test(pw) + /\d/.test(pw) + /[^A-Za-z0-9]/.test(pw) + (pw.length >= 20));
}
export const PW_LABELS = ['', 'Weak', 'Fair', 'Strong', 'Very strong'];
export const PW_COLORS = ['var(--km-line2)', 'var(--km-bad)', 'var(--km-warn)', 'var(--km-ok)', 'var(--km-ok)'];

/** Build the downloadable recovery kit (plain text; swap for PDF when the generator lands). */
export function recoveryKitBlob({ email, phrase, fingerprint }) {
  const text = `KryptaMail recovery kit\n=======================\nAccount: ${email}\nGenerated: ${new Date().toISOString()}\n\nRecovery phrase (12 words, in order):\n${phrase.map((w, i) => `${String(i + 1).padStart(2, '0')}. ${w}`).join('\n')}\n\nKey fingerprint:\n${fingerprint}\n\nAnyone holding this phrase can read your mail. Store it offline.\n`;
  return new Blob([text], { type: 'text/plain' });
}
export function downloadBlob(blob, name) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
